/**
 * The assistant's runtime, for the app shell and the assistant UI (H1-H5). assistant-ui itself
 * comes through `@/agent/aui`.
 */
import { AGENT_CONTEXTS } from "./apps";

export { agentClient } from "./agentClient";
export { AGENT_CONTEXTS } from "./apps";
export { useAgentTarget } from "./hooks/useAgentTarget";
export { useContextLabel } from "./hooks/useContextLabel";
export { useMentionCandidates, type MentionCandidate } from "./hooks/useMentionCandidates";
export { usePageContext } from "./hooks/usePageContext";
export { useReloadDefer } from "./hooks/useReloadDefer";
export { useTabDots, type TabDot, type TabDots } from "./hooks/useTabDots";
export type * from "./protocol/protocol";
export {
  ACTIVE_RUN,
  agentActions,
  type AgentState,
  type ConnectionStatus,
  type ThreadState,
} from "./store/agentSlice";
export {
  makeSelectRuntimeInput,
  selectAgentBusy,
  selectChoice,
  selectComposerFiling,
  selectFiledFiles,
  selectOpenFiling,
  selectTarget,
  selectTargetThread,
  type ToolView,
  type ViewMessage,
} from "./store/selectors";
export { GENERAL, parseContextRef, targetKey, type Target, type TargetKey } from "./store/targets";

/** The routes that show a context, derived from the one table. */
export const CONTEXT_ROUTES = Object.entries(AGENT_CONTEXTS).flatMap(([type, def]) =>
  def.route ? [{ type, route: def.route }] : []
);
